//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('collectionCalculation', {
//        templateUrl: 'views/components/views/collectionCalculation/collectionCalculation.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['ttGridFactory', function (ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_collectioncalculation.grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            })
//                .setToolbar({
//                    pdfExport: false,
//                    excelExport: false,
//                    layouts: false,
//                    wrapping: true
//                })
//                .setLoadDataFunction({ method: 2781 });
            
//            // #endregion VARIABLES & DEFINITIONS

//        }]
//    });
//})();
